(function(){
  var root=document.querySelector('.wnx-lp')||document.body;
  var t;
  window.addEventListener('scroll',function(){
    root.classList.add('wnx-scrolling');clearTimeout(t);
    t=setTimeout(function(){root.classList.remove('wnx-scrolling');},180);
  },{passive:true});
  var car=document.querySelectorAll('.wnx-lp .carousel-track');
  if('IntersectionObserver' in window && car.length){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){e.target.style.animationPlayState=e.isIntersecting?'running':'paused';});},{rootMargin:'100px'});
    car.forEach(function(c){io.observe(c);});
  }
  function unlockScroll(){
    var hasRealModal=document.querySelector('cart-drawer.active, .modal.is-open, [class*="popup"][class*="open"], .alia-modal, [class*="alia"][class*="modal"], [id^="alia-root"] [class*="overlay"]:not([style*="display: none"])');
    var bs=getComputedStyle(document.body);
    if(!hasRealModal && (bs.overflow==='hidden'||bs.position==='fixed')){
      document.body.style.setProperty('overflow','auto','important');
      document.body.style.setProperty('position','static','important');
    }
    // alia-root: nen none, con auto (nut gift bam duoc)
    document.querySelectorAll('[id^="alia-root"]').forEach(function(a){
      a.style.setProperty('pointer-events','none','important');
      [].forEach.call(a.children,function(ch){ch.style.setProperty('pointer-events','auto','important');});
    });
    var ps=document.getElementById('ps__widget_container'); if(ps) ps.style.setProperty('pointer-events','none','important');
  }
  setInterval(unlockScroll,500);
  document.addEventListener('touchstart',unlockScroll,{passive:true});
})();